import { FLUSH, REHYDRATE } from 'redux-persist'

import { Activity } from 'store/records/activity'
import {
  activityActions,
  getIdentityProgress,
  sendYesterdayActivity,
  setCustomStory,
  subscribeToProTrack,
  unsubscribeProgress,
  updateSubscribeToProTrack,
  updateUserActivity,
} from 'store/entities/identity/actions'

import { deleteStoryApiRequest, updateStoryApiRequest } from 'store/entities/feed/actions'
import { setEditStory, setHasStory, setStory } from './actions'

export const initialState = new Activity()

const activityReducer = (state = initialState, action: any) => {
  const { type, payload } = action
  switch (type) {
    case REHYDRATE: {
      return payload && payload.activity ? payload.activity : state
    }
    case FLUSH: {
      return new Activity()
    }
    case unsubscribeProgress.success.toString():
      return new Activity()
    case activityActions.commit.success.toString():
    case activityActions.did.success.toString():
    case activityActions.didnot.success.toString():
    case activityActions.complete.success.toString():
    case subscribeToProTrack.success.toString():
    case updateSubscribeToProTrack.success.toString():
    case getIdentityProgress.success.toString():
    case sendYesterdayActivity.success.toString(): {
      if (!payload || !payload.data || !payload.data.activity) {
        return new Activity()
      }
      const { activity } = payload.data
      return new Activity(activity)
    }
    case setStory.success.toString(): {
      const { story, id } = payload.data

      const newState = state.set('editStory', {
        id: null,
        editing: false,
        userActivityId: null,
      })

      if (payload.data.userActivityId === state.get('userActivityId')) {
        return newState.set('hasStory', true).set('story', {
          story,
          id,
        })
      }
      return newState
    }
    case setCustomStory.success.toString(): {
      if (payload.data.userActivityId === state.get('userActivityId')) {
        return state.set('hasStory', true)
      }

      return state
    }
    case updateUserActivity.success.toString(): {
      return state.set('showErrorMessage', payload.data.showErrorMessage)
    }
    case updateStoryApiRequest.success.toString():
      const { id: storyId } = payload.data
      const newState = state.set('editStory', {
        id: null,
        editing: false,
        userActivityId: null,
      })

      if (storyId && storyId === state.get('story').id) {
        return newState.set('hasStory', true).set('story', payload.data)
      }
      return newState
    case deleteStoryApiRequest.success.toString(): {
      const story = state.get('story')
      if (payload.storyId === story.id) {
        return state.set('hasStory', false).set('story', {
          story: null,
          id: null,
        })
      }
      return state
    }
    case setHasStory.toString(): {
      return state.set('hasStory', payload.hasStory)
    }
    case setEditStory.toString(): {
      return state.set('editStory', payload)
    }

    default:
      return state
  }
}

export default activityReducer
